var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button button--raised"},[_c('div',{staticClass:"mdc-button__ripple"}),_c('span',{staticClass:"mdc-button__label"},[_vm._t("default")],2),_c('div',{staticClass:"mdc-button__touch"})])
}
var staticRenderFns = []

export { render, staticRenderFns }